<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import Button from '../../General/Button.vue';
import { TEXT } from '../../../configs/text';
import { useSessionStore, useSignalRStore } from '../../../stores';
import { Session } from '../../../types/session';
import Iframe from '../../General/Iframe.vue';
import Fullscreen from '../../General/Fullscreen.vue';

const sessionStore = useSessionStore()
const signalr = useSignalRStore()

function handlePracticeStart() {
    signalr.startPractice()
}

const { t } = useI18n()
</script>

<template>
    <div class="p-3 h-full flex flex-col items-center justify-evenly gap-2 overflow-auto w-full">
        <Fullscreen class="p-3 h-full w-full flex flex-col items-center justify-evenly overflow-auto">
            <Iframe :src="(sessionStore.practiceUrl as string)" orientation="full"></Iframe>
        </Fullscreen>
        <Button v-if="!sessionStore.practiceQuizState?.[Session.practice]" color="warning" class="mb-auto"
            @click="handlePracticeStart">
            {{ t(TEXT.start_practice) }}
        </Button>
        <div v-else class="mb-auto">{{ t(TEXT.practice_in_progress) }}</div>
    </div>
</template>